import { LearnContentCarouselSkeleton } from '@module/mdrt-org/shared/block-components/learn-carousel-block/components/learn-content-carousel/components/learn-content-carousel-skeleton';
import { CAROUSELS_PER_PAGE } from './constants';
export const LearnCarouselContentPageSkeleton = () => {
  return Array.from({
    length: CAROUSELS_PER_PAGE
  }, (_, item) => <LearnContentCarouselSkeleton key={item} />);
};